<template>
  <ImportExport :title="$t('keywords.credentials')" type="credentials" :headers="headers" v-on="$listeners">
    <template #item.credentialName="{ item }">
      <v-text-field v-model="item.credentialName" style="margin-bottom: -2.3vh" outlined dense :rules="alphaNumericRules(item.credentialName)" />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import { alphaNumericRules } from '../../utils/rules'

export default {

  components: { ImportExport },

  data: () => ({
    alphaNumericRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('credentials.name'),
          value: 'credentialName'
        },
        {
          text: this.$t('credentials.type'),
          value: 'type'
        }
      ]
    }
  }

}
</script>
